import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import Layout from './components/Layout';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProductForm from './components/ProductForm';
import FinalReport from './components/FinalReport';
import Reports from './components/Reports';
import ProductAdmin from './components/ProductAdmin';
import ProductGroupsAdmin from './components/ProductGroupsAdmin';
import UserAdmin from './components/UserAdmin';
import Settings from './components/Settings';
import ActivityLogs from './components/ActivityLogs';
import LoadingScreen from './components/LoadingScreen';

// Kreiranje Material UI teme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function RequireAuth({ children }: { children: React.ReactElement }) {
  const isAuthenticated = !!localStorage.getItem('token');
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  return children;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <RequireAuth>
              <Layout>
                <Dashboard />
              </Layout>
            </RequireAuth>
          } />
          <Route path="/new" element={
            <RequireAuth>
              <Layout>
                <ProductForm />
              </Layout>
            </RequireAuth>
          } />
          <Route path="/edit/:id" element={
            <RequireAuth>
              <Layout>
                <ProductForm />
              </Layout>
            </RequireAuth>
          } />
          <Route path="/report" element={
            <RequireAuth>
              <Layout>
                <FinalReport />
              </Layout>
            </RequireAuth>
          } />
          <Route path="/reports" element={
            <RequireAuth>
              <Layout>
                <Reports />
              </Layout>
            </RequireAuth>
          } />
          <Route path="/products-admin" element={
            <RequireAuth>
              <Layout>
                <ProductAdmin />
              </Layout>
            </RequireAuth>
          } />
          <Route path="/product-groups-admin" element={
            <RequireAuth>
              <Layout>
                <ProductGroupsAdmin />
              </Layout>
            </RequireAuth>
          } />
          <Route path="/users-admin" element={
            <RequireAuth>
              <Layout>
                <UserAdmin />
              </Layout>
            </RequireAuth>
          } />
          <Route path="/settings" element={
            <RequireAuth>
              <Layout>
                <Settings />
              </Layout>
            </RequireAuth>
          } />
          <Route path="/activity-logs" element={
            <RequireAuth>
              <Layout>
                <ActivityLogs />
              </Layout>
            </RequireAuth>
          } />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
